import Quiz from '../../../api/Quiz';
import * as types from './mutation-types';

export const show = async ({commit}, {id}) => {
    const json = await new Quiz().show(id);

    commit(types.QUIZ, json);
    commit(types.TITLE_TRANSLATION, json.title_translation);
    commit(types.QUESTIONS, json.user_questions.map(el => el.id));
    commit(types.TITLE_TRANSLATION_ID, json.title_translation_id);
};

export const update = async ({commit}, {id, params}) => {
    await new Quiz().update(id, params)
};

export const updateQuestionsForQuiz = async ({commit}, {id, params}) => {
    await new Quiz().updateQuestionsForQuiz(id, params)
};

export const store = async ({commit}, {params}) => {
    await new Quiz().store(params)
};

export const destroy = async ({commit}, {id}) => {
    await new Quiz().destroy(id)
};

export const getAll = async ({commit}) => {
    const json = await new Quiz().getAll();

    commit(types.QUIZZES, json);
};

export default {
    destroy,
    store,
    show,
    update,
    updateQuestionsForQuiz,
    getAll
};



// WEBPACK FOOTER //
// ./src/store/modules/quiz/actions.js